import type { AssetGroup } from '@/types/asset';

export const getDefaultBoardName = ({ asset }: { asset: AssetGroup }) => {
  if (asset.type === 'music' || asset.type === 'sfx') {
    return `${asset.data.name} - ${asset.data.artist?.name}`;
  }

  if (asset.type === 'motion') {
    return `${asset.data.name} - ${asset.data.contributor?.name}`;
  }

  return 'New board';
};
